export const getItemizedString = (strings: string[]): string =>
  strings.map(string => `・${string}`).join('\n');
